<template>
  <defaultFrame :appLogoFlag="true"></defaultFrame>
</template>


<script lang="ts">
export default {
  name:'defaultFrameTop'
}
</script>
<script lang="ts" setup>
import DefaultFrame from '../defaultFrame/index.vue';
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {MenuModeEnum, MenuTypeEnum} from "@/enums/menuEnum";

baseHandler(HandlerEnum.CHANGE_LAYOUT, {
  mode: MenuModeEnum.HORIZONTAL,
  type: MenuTypeEnum.TOP_MENU,
  split: false,
});

onMounted(()=>{
  if(!(document.body.className.indexOf('defaultFrameTop-body')>=0)){
    document.body.className=document.body.className+" defaultFrameTop-body";
  }
})
</script>

<style type="text/css" lang="less">
@import './less/defaultFrameTop.less';
</style>
